<template>
  <div class="tut-arrow">
    <div class="container">
      <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.69086 9.81066V0.375C4.69086 0.167906 4.52295 0 4.31586 0H2.56586C2.35876 0 2.19086 0.167906 2.19086 0.375V9.81066H0.751514C0.0833262 9.81066 -0.251299 10.6185 0.22117 11.091L2.91051 13.7803C3.20342 14.0732 3.67829 14.0732 3.97117 13.7803L6.66051 11.091C7.13298 10.6185 6.79836 9.81066 6.13017 9.81066H4.69086Z" fill="url(#paint0_linear)"/>
        <defs>
          <linearGradient id="paint0_linear" x1="3.44084" y1="0" x2="3.44084" y2="14" gradientUnits="userSpaceOnUse">
            <stop stop-color="$mainGreen"/>
            <stop offset="1" stop-color="$mainGreen"/>
          </linearGradient>
        </defs>
      </svg>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

.tut-arrow {
  height: 20px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;

  .container {

    display: flex;
    align-items: center;
    justify-content: center;

    width: 60px;
    height: 100%;

    svg {

    }
  }
}

</style>